<div class="px-6 w-full space-y-5 mt-3">
  <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5">
    <div class="space-y-3">
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Fechas</label>
        <app-datepicker (updateDates)="setDatesOnFilter($event)" [selectedFilterRange]="1"></app-datepicker>
      </div>
      <div class="flex justify-end">
        <button pButton [label]="loading ? 'Buscando...' : 'Buscar'" [icon]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-search'"
          class="p-button-sm w-full sm:w-auto" [disabled]="loading" (click)="getMovements()"></button>
      </div>
    </div>
  </div>

  @if(loading) {
    <app-loader [inline]="true" [message]="'Buscando complementos...'"></app-loader>
  } @else if(movements.length > 0) {
    <app-custom-table [rowsByPage]="10" [headers]="headers" [elements]="movements"
      [hasButton]="true" [hasFilter]="true"></app-custom-table>
  } @else {
    <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-8 text-center">
      <i class="pi pi-inbox text-3xl text-vivid-royal-300 mb-2 block"></i>
      <p class="text-sm text-vivid-royal-400">No se encontraron complementos de pago en el rango seleccionado</p>
    </div>
  }
</div>
